/* CreateAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateQuestionComponent = require("./CreateQuestionComponent");
const policyPerms = ["auditManageLevel1", "auditManageLevel2", "auditManageLevel3"];

class CreateAction {
    constructor(logger, gameEditor, modalUserFeedback, ConfigAuditPolicy, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._configAuditPolicy = new ConfigAuditPolicy(userSession.activeOrganization.id);
        this._authActions = userSession.authorizedActions;

        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this.run = this.run.bind(this);
    }

    run() {
        return this._modalUserFeedback
            .displayCustom(new CreateQuestionComponent(this._logger), { dontHide: true })
            .then((result) => {
                this._modalUserFeedback.displayLoading();
                return this._createPolicy(result.trim()).catch((err) => {
                    this._logger.warn({ error: err }, "CreateAction._createAuditPolicy() error.");
                    return this._modalUserFeedback.displayError(err);
                });
            })
            .then((result) => {
                let editorState = {
                    fqn: Registrations.AUDIT_POLICY_EDITOR_VIEW_DETAILS,
                    viewState: { createMode: true }
                };
                let launchOpts = {
                    id: result.id,
                    title: result.properties.name
                };
                this._modalUserFeedback.hideDisplayed();
                this._gameEditor.launchAuditEditor(editorState, launchOpts);
                if (typeof this._activeView.resetSelection === "function" && typeof this._activeView.loadAndScrollTo === "function") {
                    this._activeView.resetSelection([result.id]);
                    this._activeView.loadAndScrollTo(result.id);
                }
            })
            .catch((err) => {
                this._modalUserFeedback.hideDisplayed();
                this._logger.warn({ error: err }, "CreateAction.run() - Either error or cancellation");
            });
    }

    _createPolicy(name) {
        // Defaults
        this._configAuditPolicy.name = name;
        this._configAuditPolicy.description = "";
        this._configAuditPolicy.rules = [];
        this._configAuditPolicy.permissionLevel = this._authActions.find((action) => policyPerms.indexOf(action) >= 0);
        return this._configAuditPolicy.create({ skipHooks: ["audit"] });
    }
}

module.exports = CreateAction;

CreateAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.ConfigAuditPolicy",
    "$teve.userSession",
    "gameEditor.activeView"
];

CreateAction.$displayDetails = {
    type: "Action",
    name: "CreateAction",
    icon: "configdrift.add_audit_policy",
    shown: true,
    title: "Create policy",
    order: 1
};
